import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import logo from '../../assets/images/Neuroverseai.png'; // Adjust path if necessary
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container footer-content">
        {/* Column 1: About & Social */}
        <div className="footer-column about-column">
          <img src={logo} alt="NeuroverseAI Logo" className="footer-logo" />
          <p className="footer-about-text">
            We believe in a future where AI is intuitive, accessible, and transformative. Join us on this journey to unlock possibilities and reshape what’s achievable in the digital age.
          </p>
          <div className="footer-social-links">
            <a href="https://www.facebook.com/Neuroverseai" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://www.instagram.com/neuroverseai1" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.youtube.com/@Neuroverseai68" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            <a href="https://www.linkedin.com/company/neuroverseai-official/?viewAsMember=true" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Column 2: Our Services */}
        <div className="footer-column links-column">
          <h3 className="footer-column-title">Our Services</h3>
          <ul>
            <li className="non-link">SAP SUCCESS FACTORS</li>
            <li className="non-link">SAP GRC</li>
            <li className="non-link">SAP SECURITY</li>
            <li className="non-link">SAP FICO</li>
            <li className="non-link">SAP CONCUR</li>
            <li className="non-link">SAP ARIBA</li>
            <li className="non-link">SAP SIGNAVIO</li>
            <li className="non-link">SAP S/4 HANA</li>
            <li className="non-link">SAP BTP</li>
            <li className="non-link">SAP BUSINESS AI</li>
          </ul>
        </div>

        {/* Column 3: Quick Links */}
        <div className="footer-column links-column">
          <h3 className="footer-column-title">Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about-us-2">About</a></li>
            <li><a href="/best-sap-consulting-services-usa">Consulting Services</a></li>
            <li><a href='https://neuroverse-trainings.com'>Trainings</a></li>
            <li><a href="/contact-us">Contact us</a></li>
          </ul>
        </div>

        {/* Column 4: About Us */}
        <div className="footer-column about-us-column">
          <h3 className="footer-column-title">About Us</h3>
          <p>
            At NeuroverseAI, we are revolutionizing the way people interact with artificial intelligence. Our mission is to harness the power of advanced AI to create solutions that inspire innovation, enhance productivity, and empower individuals and organizations to reach new heights.
          </p>
        </div>
      </div>
      <div className="footer-bottom-bar">
        <div className="container">
          <p>Copyright © neuroverseai.com | All rights reserved. | Design & Developed by Sidhi Digital Agency</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;